import { Link } from 'react-router-dom';
import { useCases } from '../../data/content';
import './Hero.css';

const financeFlowIcons = {
  'Nota Fiscal': '🧾',
  'IA lê': '🤖',
  'Extrai dados': '📋',
  ERP: '🔗',
  Pagamento: '💳',
};

const flowSteps = useCases.financeiro.flow.map((label) => ({
  icon: financeFlowIcons[label] || '•',
  label,
}));

function Hero() {
  return (
    <section className="hero">
      <div className="container hero-grid">
        <div className="hero-content">
          <h1>
            Automatizamos processos empresariais com{' '}
            <span className="hero-highlight">sistemas inteligentes</span>
          </h1>

          <p className="hero-text">
            Desenvolvimento sob medida, integrações, automação com IA e n8n.
          </p>

          <div className="hero-actions">
            <Link to="/diagnostico" className="btn btn-primary btn-large">
              Solicitar Diagnóstico
            </Link>
            <a href="#solucoes" className="btn btn-outline btn-large">
              Ver Soluções
            </a>
          </div>
        </div>

        <div className="hero-animation">
          <p className="hero-flow-title">Fluxo financeiro</p>
          <div className="flow-pipeline">
            {flowSteps.map((step, index) => (
              <div key={step.label} className="flow-item" style={{ '--step-index': index }}>
                <div className="flow-node">
                  <span className="flow-icon">{step.icon}</span>
                  <span className="flow-label">{step.label}</span>
                  <div className="flow-glow" />
                </div>
                {index < flowSteps.length - 1 && (
                  <div className="flow-connector">
                    <span className="connector-line" />
                    <span className="connector-arrow">↓</span>
                    <span className="connector-pulse" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
